export default __webpack_public_path__ + "static/media/bg29.8faffe2e.jpg";